import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Some recording devices are built to modify the recorded signal in a specific way. For example, a Head and Torso Simulator (HATS) modifies signals in the same way a human listener would (see lesson 2.16). A relevant aspect in the equalization of binaural recording systems is to ensure that all devices provide comparable recordings, irrespective of minor individual differences between devices.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/02/16/principle/slide-2.svg`,
            },
          },
          styles: {
            padding: "2%",
          },
        },
      },
    },
  },
};

export default principle;
